
<div class="w-100">
    <div class="mt-1" >
        <v-row class="no-frame">
            <v-col class="no-frame pr-2" :class="colWidth[0]">
                <p-dms-treeview
                    :title     = "unit.fabricNo"
                    :folder   = "folders"
                    :border   = "true"
                    :height   = "height"
                    @selected = "onDocument"
                />
            </v-col>
            <v-col class="no-frame" :class="colWidth[1]">
                <c-column-header
                    v-if   = "selected"
                    :label = "selected.name"
                    class  = "primary"
                >
                </c-column-header>
                <c-dms-viewer
                    v-if      = "selected"
                    :document = "document"
                    :border   = "false"
                    class     = "w-100 white mt-1"
                    style     = "height: calc(100% - 35px)"
                />
            </v-col>
        </v-row>
    </div>
</div>
